import script from "./NoGroup.vue?vue&type=script&lang=ts&setup=true"
export * from "./NoGroup.vue?vue&type=script&lang=ts&setup=true"

import "./NoGroup.vue?vue&type=style&index=0&id=a619c8ca&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src3567651837/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a619c8ca"]])

export default __exports__